import { Directive, ElementRef, HostBinding, Input, OnChanges, Renderer2, type SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appSkeleton]',
  standalone: true
})
export class SkeletonDirective implements OnChanges {
  @Input('appSkeleton') isActive: boolean = false;

  @HostBinding('attr.aria-busy') get ariaBusy() {
    return this.isActive ? 'true' : null;
  }

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('isActive' in changes) {
      this.toggleSkeleton(this.isActive);
    }
  }

  private toggleSkeleton(active: boolean): void {
    const host = this.el.nativeElement;
    if (active) {
      this.renderer.addClass(host, 'skeleton-active');
      this.renderer.setAttribute(host, 'data-skeleton', 'true');
    } else {
      this.renderer.removeClass(host, 'skeleton-active');
      this.renderer.removeAttribute(host, 'data-skeleton');
    }
  }
}


